export interface Metrics {
  marketShare: string;
  compareShare: string;
  growth: string;
}

export function OverTimeReportMetrics(
  currentVal: number,
  compareVal: number,
  totalGmvAllItems: number,
  totalCompareGmvAllItems: number
): Metrics {
  const marketShareNum = totalGmvAllItems ? (currentVal / totalGmvAllItems) * 100 : 0;
  const marketShare = marketShareNum.toFixed(2);

  const compareShareNum = totalCompareGmvAllItems ? (compareVal / totalCompareGmvAllItems) * 100 : 0;
  const compareShare = compareShareNum.toFixed(2);

  const growth = compareVal ? ((currentVal / compareVal - 1) * 100).toFixed(2) : '- ';

  return { marketShare, compareShare, growth };
}
